import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'components/common/types/Store.types';

export const getIsLoading = createSelector(
  (state: Store) => state.dealManagement.isLoading,
  (isLoading) => isLoading,
);
